import {API_URL} from '../../../../resources/api';

export const resumeURL : string = `${API_URL}dashboard/cashier/resume`;
